<template>
  <coozzy-card :title="$t('message.settings.ai.advertGeneration.title')">
    <div
      v-if="loading"
      style="height: 30px">
      <coozzy-spinner />
    </div>
    <div
      v-else
      class="row">
      <div class="col-12 mb-2">
        <coozzy-form-textarea
          v-model="prompt"
          :initial="prompt"
          :text="prompt"
          :rows="12"
          name="prompt">
          {{ $t('message.settings.ai.advertGeneration.prompt') }}
        </coozzy-form-textarea>
      </div>
      <div class="col-12">
        <coozzy-button
          class="float-right mt-3"
          design="primary"
          :disabled="saving"
          @click="save">
          {{ $t('message.generic.form.save') }}
        </coozzy-button>
      </div>
    </div>
  </coozzy-card>
</template>

<script lang="ts">
import Vue from 'vue'
import CoozzyCard from '@/framework/components/card/CoozzyCard.vue'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import CoozzyFormTextarea from '@/framework/components/form/textarea/CoozzyFormTextarea.vue'
import AdvertGenerationApi from '@/misc/apis/AdvertGenerationApi'
import { user } from '@/mixins/user'

export default Vue.extend({
  name: 'AiAdvertGenerationSettings',
  components: {
    CoozzyFormTextarea,
    CoozzyButton,
    CoozzySpinner,
    CoozzyCard
  },
  mixins: [user],
  data() {
    return {
      loading: false as boolean,
      saving: false as boolean,
      prompt: '' as string
    }
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    loadConfig() {
      this.loading = true
      AdvertGenerationApi.getAccountConfig(this.accountId)
        .then((response) => {
          this.prompt = response.config?.prompt || ''
        })
        .catch((error) => {
          console.log(error)
          Vue.toasted.show(this.$t('message.settings.ai.advertGeneration.loadFailed'), { type: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.saving = true
      AdvertGenerationApi.setAccountConfig(this.accountId, this.prompt)
        .then((response) => {
          this.prompt = response.config?.prompt || this.prompt
          Vue.toasted.show(this.$t('message.settings.ai.advertGeneration.savedSuccessfully'), { type: 'success' })
        })
        .catch((error) => {
          console.log(error)
          Vue.toasted.show(this.$t('message.settings.ai.advertGeneration.saveFailed'), { type: 'error' })
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
})
</script>
